import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import { useRealtimeTick } from "@/lib/realtime";

let cache = null;
const subs = new Set();
export async function refreshBrand() {
  try {
    cache = await (await fetch(`${API}/public/login`, { cache: "no-store" })).json();
    subs.forEach((f) => f(cache));
  } catch {}
}

export function useBrand() {
  const [b, setB] = useState(cache || {});
  const tick = useRealtimeTick((m) => m.path.startsWith("/api/public/login"));
  useEffect(() => { subs.add(setB); return () => subs.delete(setB); }, []);
  useEffect(() => { if (!cache || tick) refreshBrand(); }, [tick]);
  return b;
}

export const brandGlyphs = (t) => (t || "").toLocaleUpperCase("tr").replace(/A/g, "Λ");

export function BrandText({ className = "", text, testId = "brand-text" }) {
  const b = useBrand();
  const value = text ?? b.brand_text ?? "KARAHAN TEKNOLOJİ";
  return <span className={`font-brand tracking-[0.18em] ${className}`} data-testid={testId} aria-label={value}>{brandGlyphs(value)}</span>;
}

export const loginBgUrl = (b) => b.bg_type === "preset" && b.bg_preset ? `/login-bg/${b.bg_preset}.jpg`
  : b.bg_type === "upload" && b.bg_v ? `${API}/public/login-bg?v=${b.bg_v}` : null;

export const logoUrl = (b) => b.logo_preset === "karahan" ? "/brand/karahan-logo.png" : b.has_logo ? `${API}/public/logo?v=${b.logo_v}` : null;
